import React from 'react';
import BaseTabComponent from './../BaseTabComponent';
import Icon from "../../../Icon";
import minusIcon from "../../../../svgs/minus-button.svg";
import plusIcon from "../../../../svgs/plus-button.svg";

export default class Marketing extends BaseTabComponent {
    constructor(props) {
        super(props);
        this.onTableValueChange = this.onTableValueChange.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex) {
        this.props.valueChange('expenses-tab', tableIdentifier, rowCode, event.currentTarget.value, columnIndex);
    }

    handleExpand() {
        this.props.handleExpand({
            tabId: 'marketing-tab',
            tablesId: ['income-and-expenses'],
            rowsId: {
                'income-and-expenses': ['base-rent-additional-price'],
            },
        });
        this.props.setState({isMarketingAdditionalPriceVisible: !this.props.isMarketingAdditionalPriceVisible});
    }

    renderEditableValueCell(tableIdentifier, rowKey, row, columnIndex, forceStatic) {
        if (forceStatic) {
            return (
                <td className={`value-cell ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
                    key={`${rowKey}-${columnIndex}`}>
                    <span className="text value">{row.value}</span>
                </td>
            )
        }
        return (
            <td className='value-cell editable-cell' key={`${rowKey}-${columnIndex}`}>
                <label
                    className={`${row.type} ${(row.type === 'number' && (row.unit === '$' || row.unit === '%' || row.unit === 'SF' || row.unit === 'Acres' || row.unit === 'Years' || row.unit === 'bps')) ? 'formatted-number-label' : ''}`}>
                    <input value={row.value}
                           lang='en-US'
                           onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                           type={row.type}
                           placeholder={row.unit}/>
                    <div
                        className="input-display-value">{BaseTabComponent.addCommasToNumber(row.value)} {row.value ? row.unit : null}</div>
                </label>
            </td>
        );
    }

    renderStaticValueCell(tabs, cell, rowKey, colIndex, precomputedValues) {
        if (cell.empty) {
            return (<td className='value-cell empty' key={`${rowKey}-${colIndex}`}/>)
        }
        return (
            <td className={`value-cell ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`}
                key={`${rowKey}-${colIndex}`}>
                <span className='text value'>{cell.getComputedValue(tabs, rowKey, precomputedValues).displayValue}</span>
                {
                    cell.hasExpandButton &&
                    <span className='expand-button' onClick={() => this.handleExpand()}>
                        <Icon svg={this.props.isMarketingAdditionalPriceVisible ? minusIcon : plusIcon}/>
                    </span>
                }
                {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
            </td>
        );
    }

    renderTable(tables, tableIdentifier, precomputedValues) {
        const table = tables[tableIdentifier];
        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            const nameCell = BaseTabComponent.renderNameCell(row);
            let valueCell;
            if (row.editable) {
                valueCell = this.renderEditableValueCell(tableIdentifier, key, row);
            } else {
                valueCell = this.renderStaticValueCell(this.props.tabs, row, null, null, precomputedValues);
            }
            return (
                <tr key={key} className={key}>{nameCell}{valueCell}</tr>
            );
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                {table.headerRow && table.headerRow.length ?
                    <tr>{table.headerRow.map((cell, index) => {
                        return (
                            <td className='header-cell' key={cell ? cell : index}>
                                <div className='text'>{cell}</div>
                            </td>
                        )
                    })}</tr>
                    : null
                }

                {tableRows}
                </tbody>
            </table>
        )
    }

    renderMatrixTable(tables, tableIdentifier, precomputedValues, forceStaticCells, nonReimbExpenses) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            const nameCell = BaseTabComponent.renderNameCell(row);

            if (['expenses', 'income-and-expenses'].includes(tableIdentifier) && key === 'non-reimbursable-expenses' && !nonReimbExpenses)
                return;

            return <tr key={key} className={key}>
                {table.hasNamesColumn ? nameCell : null}

                {row.valueCells.map((cell, index) => {
                    if (cell === null) {
                        return <td key={index} className='invisible'/>
                    }
                    if (cell.hidden) {
                        return;
                    }
                    if (cell.editable) {
                        return this.renderEditableValueCell(tableIdentifier, key, cell, index, forceStaticCells);
                    } else {
                        return this.renderStaticValueCell(this.props.tabs, cell, key, index, precomputedValues);
                    }
                })}
            </tr>
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                {table.headerRow && table.headerRow.length ?
                    <tr>{
                        table.headerRow.map((cell, index) => {
                            return (
                                <td className='header-cell' key={index}>
                                    <div className='text'>{cell}</div>
                                </td>
                            )
                        })
                    }</tr>
                    : null
                }

                {tableRows}

                {table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                    <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                        const cell = table.footerRow.valueCells[key];
                        if (cell.empty) {
                            return (<td className='value-cell empty' key={key}/>)
                        }
                        if (cell) {
                            return (
                                <td key={key}>
                                    <div
                                        className='text'>{cell.getComputedValue(this.props.tabs, null, precomputedValues).displayValue}</div>
                                </td>
                            );
                        }
                        return <td className='invisible' key={key}/>;
                    })}</tr>
                    : null
                }
                </tbody>
            </table>
        )
    }

    render() {
        const marketingTab = this.props.tabs['marketing-tab'];
        const currentRRTab = this.props.tabs['current-rr-tab'];
        const generalInformation = this.props.tabs['property-information-tab'].tables['general-information'];
        const nonReimbExpenses = this.props.tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[2].value;

        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);

        return (
            <div className="Marketing">
                <div className="Financials_table_container">
                    <h3 className="Financials_table_title">{generalInformation.rows['property-name'].value}</h3>
                    <div className="text">{generalInformation.rows['address'].value}</div>
                    <div
                        className="text">{generalInformation.rows['city'].value}, {generalInformation.rows['state'].value}</div>
                    <div className="tables-flex-row">
                        <div className="column">
                            {this.renderTable(marketingTab.tables, 'offering-summary', precomputedValues)}
                            {this.renderMatrixTable(marketingTab.tables, 'expenses', precomputedValues, null, nonReimbExpenses)}
                        </div>
                        <div className="column">
                            {this.renderMatrixTable(marketingTab.tables, 'income-and-expenses', precomputedValues, null, nonReimbExpenses)}
                        </div>
                    </div>
                </div>
                <div className="Financials_table_container">
                    <h3 className="Financials_table_title">Tenants</h3>

                    <div className="scrollable-tables">
                        <div className="left-table">
                            <table className="supra-header">
                                <tbody>
                                <tr>
                                    <td/>
                                </tr>
                                </tbody>
                            </table>
                            {this.renderMatrixTable(currentRRTab.tables, 'top-left', precomputedValues)}
                            {this.renderMatrixTable(currentRRTab.tables, 'general-information', precomputedValues, true)}
                            {this.renderMatrixTable(currentRRTab.tables, 'sumed-general-information', precomputedValues)}
                        </div>
                        <div className="right-table">
                            <div className="main-table">
                                <table className="supra-header rent-roll-supra-header">
                                    <tbody>
                                    <tr>
                                        <td>Rent Roll</td>
                                    </tr>
                                    </tbody>
                                </table>
                                {this.renderMatrixTable(marketingTab.tables, 'rent-roll-header', precomputedValues)}
                                {this.renderMatrixTable(marketingTab.tables, 'rent-roll', precomputedValues)}
                                {this.renderMatrixTable(marketingTab.tables, 'sumed-rent-roll', precomputedValues)}
                            </div>
                            <div className="main-table">
                                <table className="supra-header reimbursements-supra-header">
                                    <tbody>
                                    <tr>
                                        <td>Reimbursements</td>
                                    </tr>
                                    </tbody>
                                </table>
                                {this.renderMatrixTable(marketingTab.tables, 'reimbursements-header', precomputedValues)}
                                {this.renderMatrixTable(marketingTab.tables, 'reimbursements', precomputedValues)}
                                {this.renderMatrixTable(marketingTab.tables, 'sumed-reimbursements', precomputedValues)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}